/* eslint-disable import/no-anonymous-default-export */
import apiCall from "./apiCall";

export default {

    async getOrganiseMarksList(class_id, paper_id, stream_id) {
        let data={
            class_id:class_id,
            paper_id:paper_id,
            stream_id:stream_id
        }
        const server_response = await apiCall("marks/organise/list", data);
        return server_response;
    },

    async organiseMarks(student_list, class_id, paper_id) {
        let data={
            student_list:student_list,
            class_id:class_id,
            paper_id:paper_id
        }
        const server_response = await apiCall("marks/organise", data);
        return server_response;
    
    },

  
    async organiseAllSubjectStudents(class_id, paper_id) {

      let data={
          class_id:class_id,
          paper_id:paper_id
      }

      const server_response = await apiCall("marks/organise/subject", data);
      return server_response;

  },

  async clearAllSubjectStudents(class_id, paper_id) {
    let data={
        class_id:class_id,
        paper_id:paper_id
    }
    const server_response = await apiCall("marks/organise/subject/clear", data);
    return server_response;
  },


    async removeStudent(mark_id) {
        let data={
            mark_id:mark_id,
        }
        const server_response = await apiCall("marks/remove", data);
        return server_response;
    },

    async getMarksEntrySheet(data) {
      const server_response = await apiCall("marks/entry/sheet", data);
      return server_response;
    },

    async enterMark(data) {
     
      let response = await apiCall("mark/add", data);
      return response;
    },

    async organiseFromHistory(class_id) {
      
      let data={
          class_id:class_id,
      }

      const server_response = await apiCall("marks/organise/history", data);
      return server_response;

  },

  async copyMarks(data) {
    const server_response = await apiCall("exam/marks/marksutility/copy_marks", data);
    return server_response;
  }

}